export default __webpack_public_path__ + "static/media/FS-HOME-BANNER-PRINCIPAL-TELEFONO.2cbbfa12.png";